import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const state = {
  description: '',
  defaultImgUrl: '',
  documentTitle: '',
  keywords: '',
  faviconURL: '',
  availableLocales: {},
  currentLocale: 'EN',
  translations: {},
  settingsPageLocales: [],
  localesMappedWithIndices: {},
  activeLocale: 0,
  externalPageLocale: 'EN',
  externalTranslations: {},
  defaultLanguage: 'EN',
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/i18n/index.js